import { simpleProjectServiceUrl } from '../../../config/environment';
import { callApi } from '../../../utils/callApi';

export const getProjectByCodeOrId = async (
  codeOrId: string,
): Promise<SimpleProjectServiceAPI.ProjectDto> => {
  const url = `${simpleProjectServiceUrl}/api/v1/projects/${codeOrId}`;
  const { data } = await callApi<SimpleProjectServiceAPI.ProjectDto>(url, 'GET');
  return data;
};
